import { Popup, ErrorPopup, httpAxios } from "../../core/classes/BaseStore";
import {
  BaseApiRoutes,
  BaseApiGetters,
  ApiAsyncHelper,
} from "@/modules/core/classes/Api";

import { ActivityModel } from "@/modules/activities/viewmodels/Activity";

export const state = {
  activities: [],
};

export const getters = Object.assign(
  {
    activities: (state) => {
      return state.activities;
    },
    activity: (state) => (Id) => {
      return state.activities.find((e) => e.id === Id);
    },
    activityCategoryId: (state) => (Id) => {
      let activity = state.activities.find((e) => e.id === Id);
      return activity ? activity.activity_category_id : false;
    },
  },
  new BaseApiGetters(
    process.env.VUE_APP_BASE_URL + "/api/activities",
    ActivityModel,
    {
      AfterShow: (name, data) => {
        let el = state.activities.find((e) => e.id === data.id);
        if (el) {
          el = data;
        } else {
          state.activities.push(data);
        }
        return data;
      },
    },
    {
      /**
       * Returns all system and my activities
       * this.$store.getters['activity/api'].Custom.AllMy()
       */
      AllMy: async () => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api
          .call("get", process.env.VUE_APP_BASE_URL + "/api/activities/allmy")
          .catch((err) => {
            throw Error(err);
          });

        let data = ApiResult.map((Entry) => {
          return new ActivityModel(Entry);
        });

        data.forEach((e) => {
          let foundElement = state.activities.find((a) => a.id === e.id);
          if (foundElement) {
            Object.assign(foundElement, e);
          } else {
            state.activities.push(e);
          }
        });

        return data;
      },

      /**
       * Returns all indexed system and my activities
       * this.$store.getters['activity/api'].Custom.AllMyIndex()
       */
      AllMyIndex: async (Page) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api
          .call("get", process.env.VUE_APP_BASE_URL + "/api/activities/allmy-index", {params: Page})
          .catch((err) => {
            throw Error(err);
          });

          ApiResult.data = ApiResult.data.map((Entry) => {
            return new ActivityModel(Entry);
          });

        ApiResult.data.forEach((e) => {
          let foundElement = state.activities.find((a) => a.id === e.id);
          if (foundElement) {
            Object.assign(foundElement, e);
          } else {
            state.activities.push(e);
          }
        });

        return ApiResult;
      },

      /**
       * Searches for activities
       * this.$store.getters['activity/api'].Custom.Search()
       */
      Search: async (Data) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api
          .call(
            "get",
            process.env.VUE_APP_BASE_URL + "/api/activities/search",
            { params: { search: Data.search } }
          )
          .catch((err) => {
            throw Error(err);
          });

        let data = ApiResult.map((e) => {
          return new ActivityModel(e);
        });

        return data;
      },
    }
  )
);

// mutations
export const mutations = {};

export const actions = new BaseApiRoutes(
  process.env.VUE_APP_BASE_URL + "/api/activities",
  [],
  {}
);
